import { Profile } from 'oidc-client';
import { DrawerState } from '../../../core/models/enum';
import { TeamFormInitialValues } from '../../../core/models/InitialValues';
import OpponentTeamForm from './OpponentTeamForm';

interface OwnProps {
    userProfile: Profile;
    initialValues?: TeamFormInitialValues;
    handleClose: (drawerMode: DrawerState, id?: string) => void;
    refreshAfterSave: () => void;
}

export type Props = OwnProps;

export default OpponentTeamForm;
